import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import Button, { ButtonProps } from '@atlaskit/button';
import { gridSize } from '@atlaskit/theme';
export default (function (props) {
  return React.createElement(Button, _extends({}, props, {
    appearance: "subtle",
    spacing: "none",
    theme: function theme(currentTheme, themeProps) {
      var _currentTheme = currentTheme(themeProps),
          buttonStyles = _currentTheme.buttonStyles,
          rest = _objectWithoutProperties(_currentTheme, ["buttonStyles"]);

      var halfGridSize = gridSize() / 2;
      return _objectSpread({
        buttonStyles: _objectSpread({}, buttonStyles, {
          paddingLeft: "".concat(halfGridSize, "px"),
          paddingRight: "".concat(halfGridSize, "px"),
          'html[dir=rtl] &': {
            transform: 'rotate(180deg)'
          }
        })
      }, rest);
    }
  }));
});